<template>
  <carousel
    :navigate-to="currentPage"
    :class="{ 'bundle-items-carousel': !hideNavigation }"
    :per-page="perPage"
    :navigation-enabled="!hideNavigation"
    :pagination-enabled="false"
    :mouse-drag="false"
  >
    <template #navigation>
      <div class="nav-btn-wrapper prev-btn-wrapper">
        <v-btn
          :disabled="!currentPage"
          class="nav-btn prev-btn"
          icon
          @click="showPrevPage"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </div>
      <div class="nav-btn-wrapper next-btn-wrapper">
        <v-btn
          class="nav-btn next-btn"
          icon
          :disabled="!nextBtnEnabled"
          @click="showNextPage"
        >
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
      </div>
    </template>
    <slide
      v-for="(bundleItem, i) in bundleItems"
      :key="i"
      class="carousel-slide"
    >
      <v-card class="bundle-item ma-3">
        <img class="bundle-item-img" :src="bundleItem.menuItem.image" />
        <v-card-title class="bundle-item-name">
          {{ bundleItem.menuItem.name }}
        </v-card-title>
        <v-card-text class="bundle-item-description">
          {{ bundleItem.menuItem.description }}
        </v-card-text>
      </v-card>
    </slide>
  </carousel>
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    name: 'BundleItemsCarousel',
    components: {
      Carousel,
      Slide,
    },
    props: {
      bundleItems: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        currentPage: 0,
        perPage: 2,
        windowWidth: 0,
      }
    },
    computed: {
      nextBtnEnabled () {
        return (
          this.currentPage < Math.ceil(this.bundleItems.length / this.perPage) - 1
        )
      },
      hideNavigation () {
        return !(Math.ceil(this.bundleItems.length / this.perPage) - 1)
      },
    },
    watch: {
      windowWidth () {
        if (this.windowWidth < 500) {
          this.perPage = 1
        } else if (this.windowWidth < 730) {
          this.perPage = 2
        } else if (this.windowWidth < 960) {
          this.perPage = 3
        } else if (this.windowWidth < 1320) {
          this.perPage = 2
        } else if (this.windowWidth < 1500) {
          this.perPage = 3
        } else if (this.windowWidth < 2020) {
          this.perPage = 4
        } else if (this.windowWidth < 2300) {
          this.perPage = 5
        } else {
          this.perPage = 6
        }
      },
    },
    created () {
      window.addEventListener('resize', this.setWindowWidth)
      this.setWindowWidth()
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.setWindowWidth)
    },
    methods: {
      showPrevPage () {
        if (this.currentPage) {
          this.currentPage--
        }
      },
      showNextPage () {
        if (this.nextBtnEnabled) {
          this.currentPage++
        }
      },
      setWindowWidth () {
        this.windowWidth = window.innerWidth
      },
    },
  }
</script>

<style scoped lang="less">
::v-deep {
  .VueCarousel-inner {
    //display: inline-flex;
  }
}

.carousel-wrapper {
  display: flex;
  max-width: 100%;
  position: relative;
}
.carousel-slide {
  display: inline-flex;
  justify-content: center;
}
.bundle-items-carousel {
  padding: 0 40px;
}
.nav-btn-wrapper {
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 1000;
  top: 0;
  bottom: 0;
}
.prev-btn-wrapper {
  left: 0;
}
.next-btn-wrapper {
  right: 0;
}

.bundle-item {
  border-radius: 30px;
  max-width: 270px;

  //@media (max-width: 1770px) {
  //  max-width: 290px;
  //}

  @media (max-width: 1600px) {
    max-width: 220px;
  }

  @media (max-width: 1500px) {
    max-width: 230px;
  }

  @media (max-width: 1320px) {
    max-width: 260px;
  }

  &-img {
    max-width: 100%;
    object-fit: contain;
  }

  &-info {
    display: flex;
    flex-direction: column;
  }

  &-name {
    font-size: 14px;
    font-weight: 500;
  }

  &-description {
    font-size: 13px;
    color: #000 !important;
  }
}
</style>
